<script setup>
import { ref } from 'vue';
import PageHeader from '../common/PageHeader.vue';
import TabulatorRemote from '@/components/common/TabulatorRemote.vue';
import getResultColumns from '@/columns/results.js';
import PublicationExports from './PublicationExports.vue'

const tabRef = ref();

const resultColumns = getResultColumns(() => {
  tabRef.value?.reloadData();
});
</script>

<template>
  <div class="mainContainer">
    <PageHeader
      title="Results"
      subtitle="View and export student test results and analytics"
      icon="bi-bar-chart-line"
      color="teal"
    />



    <p>Choose a publication and download the results</p>
    
    <PublicationExports />

    <!-- <TabulatorRemote
      ref="tabRef"
      :columns="resultColumns"
      apiUrl="http://localhost:4000/api/results/summaries"
      :pagination="false"
      :header-filters="true"
      tableType="results"
    /> -->
  </div>
</template>

<style scoped>
.mainContainer {
  padding: 20px;
  background-color: #F8F9FA;
  border-left: 1px gainsboro solid;
}
</style>
